import React, { useEffect, useState } from 'react';
import { notification } from '../../hocs/notification';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import {
    FaHeading,
    FaUser,
    FaMapMarkerAlt,
    FaSeedling,
    FaTractor,
    FaLandmark,
    FaMoneyBillWave,
    FaSave,
    FaArrowLeft,
    FaInfoCircle,
    FaPlus,
    FaTrash
} from 'react-icons/fa';
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Input,
    Label,
    InputGroup,
    InputGroupText,
    Spinner,
    Button,
    Alert,
    Badge,
    Progress
} from 'reactstrap';

const AddFarmer = ({ back }) => {
    const [loading, setLoading] = useState(false);
    const [hindiNameLoading, setHindiNameLoading] = useState(false);
    const [regNo, setRegNo] = useState('0');
    const [name, setName] = useState('');
    const [nameHin, setNameHin] = useState('');
    const [spouseName, setSpouseName] = useState('');
    const [spouseNameHin, setSpouseNameHin] = useState('');
    const [age, setAge] = useState('');
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('');
    const [category, setCategory] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [altMobileNo, setAltMobileNo] = useState('');

    const [state, setState] = useState('0');
    const [stateOpt, setStateOpt] = useState('');
    const [district, setDistrict] = useState('0');
    const [districtOpt, setDistrictOpt] = useState('');
    const [block, setBlock] = useState('0');
    const [blockOpt, setBlockOpt] = useState('');
    const [village, setVillage] = useState('0');
    const [villageOpt, setVillageOpt] = useState('');
    const [address, setAddress] = useState('');

    const [season, setSeason] = useState('0');
    const [seasonName, setSeasonName] = useState('');
    const [crop, setCrop] = useState('0');
    const [cropName, setCropName] = useState('');
    const [cropPtnList, setCropPtnList] = useState([]);
    const [cropPtnListData, setCropPtnListData] = useState([]);
    const [financialYear, setFinancialYear] = useState('0');
    const [cropArea, setCropArea] = useState('');
    const [cropHarvesting, setCropHarvesting] = useState('');

    const [facilityType, setFacilityType] = useState('0');
    const [facilityTypeName, setFacilityTypeName] = useState('');
    const [facilityList, setFacilityList] = useState([]);
    const [facilityListData, setFacilityListData] = useState([]);

    const [plotNo, setPlotNo] = useState('');
    const [holdingNo, setHoldingNo] = useState('');
    const [area, setArea] = useState('');
    const [areaType, setAreaType] = useState('0');
    const [areaTypeName, setAreaTypeName] = useState('');
    const [landList, setLandList] = useState([]);
    const [landListData, setLandListData] = useState([]);

    const [loanAccountNo, setLoanAccountNo] = useState('');
    const [loanType, setLoanType] = useState('');
    const [loanAmt, setLoanAmt] = useState('');
    const [loanDate, setLoanDate] = useState('');
    const [totLoanPayment, setTotLoanPayment] = useState('');
    const [loanOutstandingAmt, setLoanOutstandingAmt] = useState('');

    // Form completion progress
    const [formProgress, setFormProgress] = useState(0);

    useEffect(() => {
        get_state_list();
        calculateProgress();
    }, [name, gender, category, state, district, block, village, mobileNo]);

    const calculateProgress = () => {
        const requiredFields = [name, gender, category, state, district, block, village, mobileNo];
        const filledFields = requiredFields.filter(field => field && field !== '0').length;
        const progress = Math.round((filledFields / requiredFields.length) * 100);
        setFormProgress(progress);
    };

    const get_state_list = (e) => {
        let postData = [{ "country_code": "1" }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.state_code}> {row.state_name}</option>
                    )
                });
                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_dist_list = (e) => {
        setState(e.target.value);
        let postData = [{ "state_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.district_code}> {row.district_name}</option>
                    )
                });
                setDistrictOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_block_list = (e) => {
        setDistrict(e.target.value);
        let postData = [{ "dist_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.block_code}> {row.block_name}</option>
                    )
                });
                setBlockOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_village_list = (e) => {
        setBlock(e.target.value);
        let postData = [{ "block_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_village_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.village_code}> {row.village_name}</option>
                    )
                });
                setVillageOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const add_handler = (e) => {
        e.preventDefault();
        setLoading(true);

        let flag = true;

        if (gender === "0") {
            flag = false;
            let notify = notification({ message: "Please select gender.", type: 'warn' });
            notify();
        }
        if (category === "0") {
            flag = false;
            let notify = notification({ message: "Please select category.", type: 'warn' });
            notify();
        }
        if (state === "0") {
            flag = false;
            let notify = notification({ message: "Please select state.", type: 'warn' });
            notify();
        }
        if (district === "0") {
            flag = false;
            let notify = notification({ message: "Please select district.", type: 'warn' });
            notify();
        }
        if (block === "0") {
            flag = false;
            let notify = notification({ message: "Please select block.", type: 'warn' });
            notify();
        }
        if (village === "0") {
            flag = false;
            let notify = notification({ message: "Please select village.", type: 'warn' });
            notify();
        }

        if (flag) {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": "10001",
                "f_reg_no": regNo,
                "f_name": name,
                "f_name_ne": nameHin,
                "age": age,
                "dob": dob,
                "mobile_no": mobileNo,
                "mobile_no_2": altMobileNo,
                "gender": gender,
                "category": category,
                "f_spouse_name": spouseName,
                "f_spouse_name_ne": spouseNameHin,
                "shareholder": "1",
                "state_id": state,
                "dist_id": district,
                "block_id": block,
                "pan_id": "0",
                "vill_id": village,
                "address": address,
                "crop_pattern_list": cropPtnList,
                "facility_list": facilityList,
                "land_list": landList
            }];

            axios({
                method: 'post',
                url: mainurl + 'Farmer/box_farmer_add',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            })
                .then(function (response) {
                    if (response.data[0].retcode === 101) {
                        let notify = notification({
                            message: "Farmer added Successfully.",
                            type: 'success',
                            time: true,
                            position: 'center'
                        });
                        notify();
                        back();
                    }
                })
                .catch(error => {
                    let notify = notification({
                        message: "Submit failed! Try Again",
                        type: 'error',
                        time: true
                    });
                    notify();
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }

    const translate_text_handler = () => {
        // Translation logic here
    }

    const add_crop_pattern = () => {
        let flag = true;

        if (season === "0") {
            flag = false;
            let notify = notification({ message: "Please Select Season", type: 'warn' });
            notify();
        }
        if (crop === "0") {
            flag = false;
            let notify = notification({ message: "Please Select Crop", type: 'warn' });
            notify();
        }
        if (!cropArea) {
            flag = false;
            let notify = notification({ message: "Please Enter Crop Area", type: 'warn' });
            notify();
        }

        if (flag) {
            let temp = [...cropPtnList];
            let cropDtl = {
                "crop_id": crop,
                "season_id": season,
                "crop_name": cropName,
                "season_name": seasonName,
                "financial_year": financialYear,
                "crop_area": cropArea,
                "crop_harvesting": cropHarvesting
            };
            temp.push(cropDtl);
            setCropPtnList(temp);

            let list = temp.map((row, index) => {
                return (
                    <div key={index} className="d-flex align-items-center justify-content-between bg-light p-2 rounded mb-2">
                        <div className="d-flex gap-3 flex-wrap">
                            <Badge color="primary">{row.crop_name}</Badge>
                            <Badge color="info">{row.season_name}</Badge>
                            <Badge color="success">{row.financial_year}</Badge>
                            <Badge color="warning">{row.crop_area} acres</Badge>
                            <Badge color="secondary">{row.crop_harvesting}</Badge>
                        </div>
                        <Button
                            size="sm"
                            color="danger"
                            outline
                            onClick={() => removeCropPattern(index)}
                        >
                            <FaTrash size={12} />
                        </Button>
                    </div>
                )
            });
            setCropPtnListData(list);

            // Reset fields
            setCrop('0');
            setSeason('0');
            setCropName('');
            setSeasonName('');
            setFinancialYear('0');
            setCropArea('');
            setCropHarvesting('');
        }
    }

    const removeCropPattern = (index) => {
        const newList = cropPtnList.filter((_, i) => i !== index);
        setCropPtnList(newList);

        const newListData = newList.map((row, i) => {
            return (
                <div key={i} className="d-flex align-items-center justify-content-between bg-light p-2 rounded mb-2">
                    <div className="d-flex gap-3 flex-wrap">
                        <Badge color="primary">{row.crop_name}</Badge>
                        <Badge color="info">{row.season_name}</Badge>
                        <Badge color="success">{row.financial_year}</Badge>
                        <Badge color="warning">{row.crop_area} acres</Badge>
                        <Badge color="secondary">{row.crop_harvesting}</Badge>
                    </div>
                    <Button
                        size="sm"
                        color="danger"
                        outline
                        onClick={() => removeCropPattern(i)}
                    >
                        <FaTrash size={12} />
                    </Button>
                </div>
            )
        });
        setCropPtnListData(newListData);
    }

    const add_facility = () => {
        let flag = true;

        if (facilityType === "0") {
            flag = false;
            let notify = notification({ message: "Please Select Facility Type.", type: 'warn' });
            notify();
        }

        if (flag) {
            let temp = [...facilityList];
            let facilityDtl = { "facility_master_id": facilityType, "typeName": facilityTypeName };
            temp.push(facilityDtl);
            setFacilityList(temp);

            let list = temp.map((row, index) => {
                return (
                    <div key={index} className="d-flex align-items-center justify-content-between bg-light p-2 rounded mb-2">
                        <Badge color="info">{row.typeName}</Badge>
                        <Button
                            size="sm"
                            color="danger"
                            outline
                            onClick={() => removeFacility(index)}
                        >
                            <FaTrash size={12} />
                        </Button>
                    </div>
                )
            });
            setFacilityListData(list);

            setFacilityType('0');
            setFacilityTypeName('');
        }
    }

    const removeFacility = (index) => {
        const newList = facilityList.filter((_, i) => i !== index);
        setFacilityList(newList);

        const newListData = newList.map((row, i) => {
            return (
                <div key={i} className="d-flex align-items-center justify-content-between bg-light p-2 rounded mb-2">
                    <Badge color="info">{row.typeName}</Badge>
                    <Button
                        size="sm"
                        color="danger"
                        outline
                        onClick={() => removeFacility(i)}
                    >
                        <FaTrash size={12} />
                    </Button>
                </div>
            )
        });
        setFacilityListData(newListData);
    }

    const Add_land_area = () => {
        let flag = true;

        if (plotNo === "") {
            flag = false;
            let notify = notification({ message: "Please Add plot No.", type: 'warn' });
            notify();
        }
        if (holdingNo === "") {
            flag = false;
            let notify = notification({ message: "Please Add holding No.", type: 'warn' });
            notify();
        }
        if (area === "") {
            flag = false;
            let notify = notification({ message: "Please Add area.", type: 'warn' });
            notify();
        }
        if (areaType === "0") {
            flag = false;
            let notify = notification({ message: "Please select area type.", type: 'warn' });
            notify();
        }

        if (flag) {
            let temp = [...landList];
            let landDtl = {
                "f_plot_no": plotNo,
                "holding_no": holdingNo,
                "holding_area": area,
                "holding_type_id": areaType,
                "typeName": areaTypeName
            };
            temp.push(landDtl);
            setLandList(temp);

            let list = temp.map((row, index) => {
                return (
                    <div key={index} className="d-flex align-items-center justify-content-between bg-light p-2 rounded mb-2">
                        <div className="d-flex gap-3 flex-wrap">
                            <Badge color="primary">Plot: {row.f_plot_no}</Badge>
                            <Badge color="info">Holding: {row.holding_no}</Badge>
                            <Badge color="success">{row.holding_area} Acre</Badge>
                            <Badge color="warning">{row.typeName}</Badge>
                        </div>
                        <Button
                            size="sm"
                            color="danger"
                            outline
                            onClick={() => removeLandArea(index)}
                        >
                            <FaTrash size={12} />
                        </Button>
                    </div>
                )
            });
            setLandListData(list);

            setPlotNo('');
            setHoldingNo('');
            setArea('');
            setAreaType('0');
            setAreaTypeName('');
        }
    }

    const removeLandArea = (index) => {
        const newList = landList.filter((_, i) => i !== index);
        setLandList(newList);

        const newListData = newList.map((row, i) => {
            return (
                <div key={i} className="d-flex align-items-center justify-content-between bg-light p-2 rounded mb-2">
                    <div className="d-flex gap-3 flex-wrap">
                        <Badge color="primary">Plot: {row.f_plot_no}</Badge>
                        <Badge color="info">Holding: {row.holding_no}</Badge>
                        <Badge color="success">{row.holding_area} Acre</Badge>
                        <Badge color="warning">{row.typeName}</Badge>
                    </div>
                    <Button
                        size="sm"
                        color="danger"
                        outline
                        onClick={() => removeLandArea(i)}
                    >
                        <FaTrash size={12} />
                    </Button>
                </div>
            )
        });
        setLandListData(newListData);
    }

    return (
        <>
            {/* Header with Progress */}
            <Card className="mb-3 border-0 shadow-sm ">
                <CardHeader className="bg-primary text-white">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <FaUser size={20} />
                            <div>
                                <h5 className="mb-0">Add New Farmer</h5>
                                <small>Complete all required fields to register a farmer</small>
                            </div>
                        </div>
                        <div className="text-end">
                            <div className="mb-1">Form Progress</div>
                            <div className="d-flex align-items-center gap-2">
                                <Progress
                                    value={formProgress}
                                    color={formProgress === 100 ? "success" : "warning"}
                                    style={{ width: '100px', height: '8px' }}
                                />
                                <span className="fw-bold">{formProgress}%</span>
                            </div>
                        </div>
                    </div>
                </CardHeader>
            </Card>

            <Form onSubmit={add_handler}>
                {/* Basic Information */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaInfoCircle className="text-primary" />
                            <h6 className="mb-0 text-primary">Basic Information</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Registration Number <small className="text-muted">(Optional)</small></Label>
                                    <Input
                                        type="text"
                                        value={regNo}
                                        onChange={(e) => setRegNo(e.target.value)}
                                        className="form-control-sm"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Full Name <span className="text-danger">*</span></Label>
                                    <Input
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        onKeyPress={(e) => !/^[a-zA-Z\s]*$/.test(e.key) && e.preventDefault()}
                                        required
                                        className="form-control-sm"
                                        placeholder="Enter farmer's full name"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Name (Regional Language) <span className="text-danger">*</span></Label>
                                    <InputGroup size="sm">
                                        <Input
                                            type="text"
                                            value={nameHin}
                                            onChange={(e) => setNameHin(e.target.value)}
                                            required
                                            placeholder="Enter name in regional language"
                                        />
                                        <InputGroupText
                                            className="bg-primary text-white cursor-pointer"
                                            onClick={!hindiNameLoading ? translate_text_handler : undefined}
                                        >
                                            {hindiNameLoading ?
                                                <Spinner size="sm" /> :
                                                <FaHeading />
                                            }
                                        </InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Spouse Name <span className="text-danger">*</span></Label>
                                    <Input
                                        type="text"
                                        value={spouseName}
                                        onChange={(e) => setSpouseName(e.target.value)}
                                        onKeyPress={(e) => !/^[a-zA-Z\s]*$/.test(e.key) && e.preventDefault()}
                                        required
                                        className="form-control-sm"
                                        placeholder="Enter spouse name"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Spouse Name (Regional Language) <span className="text-danger">*</span></Label>
                                    <InputGroup size="sm">
                                        <Input
                                            type="text"
                                            value={spouseNameHin}
                                            onChange={(e) => setSpouseNameHin(e.target.value)}
                                            required
                                            placeholder="Enter spouse name in regional language"
                                        />
                                        <InputGroupText
                                            className="bg-primary text-white cursor-pointer"
                                            onClick={!hindiNameLoading ? translate_text_handler : undefined}
                                        >
                                            {hindiNameLoading ?
                                                <Spinner size="sm" /> :
                                                <FaHeading />
                                            }
                                        </InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Age <span className="text-danger">*</span></Label>
                                    <Input
                                        type="text"
                                        maxLength={3}
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        value={age}
                                        onChange={(e) => setAge(e.target.value)}
                                        required
                                        className="form-control-sm"
                                        placeholder="Age"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Date of Birth</Label>
                                    <Input
                                        type="date"
                                        value={dob}
                                        onChange={(e) => setDob(e.target.value)}
                                        className="form-control-sm"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Gender <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={gender}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Gender--</option>
                                        <option value="1">Male</option>
                                        <option value="2">Female</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Category <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={category}
                                        onChange={(e) => setCategory(e.target.value)}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Category--</option>
                                        <option value="1">General</option>
                                        <option value="2">OBC</option>
                                        <option value="3">ST</option>
                                        <option value="4">SC</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Mobile Number <span className="text-danger">*</span></Label>
                                    <Input
                                        type="text"
                                        maxLength={10}
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        value={mobileNo}
                                        onChange={(e) => setMobileNo(e.target.value)}
                                        required
                                        className="form-control-sm"
                                        placeholder="Primary mobile number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Alternate Mobile Number</Label>
                                    <Input
                                        type="text"
                                        maxLength={10}
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        value={altMobileNo}
                                        onChange={(e) => setAltMobileNo(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Alternate mobile number"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Geographical Information */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaMapMarkerAlt className="text-success" />
                            <h6 className="mb-0 text-success">Geographical Information</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">State <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={state}
                                        onChange={get_dist_list}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select State--</option>
                                        {stateOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">District <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={district}
                                        onChange={get_block_list}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select District--</option>
                                        {districtOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Block <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={block}
                                        onChange={get_village_list}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Block--</option>
                                        {blockOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Village <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={village}
                                        onChange={(e) => setVillage(e.target.value)}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Village--</option>
                                        {villageOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Address</Label>
                                    <Input
                                        type="textarea"
                                        rows={2}
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Enter detailed address"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Loan Details */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaMoneyBillWave className="text-warning" />
                            <h6 className="mb-0 text-warning">Loan Details</h6>
                            <small className="text-muted">(Optional)</small>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Loan Account No.</Label>
                                    <Input
                                        type="text"
                                        value={loanAccountNo}
                                        onChange={(e) => setLoanAccountNo(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Enter loan account number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Loan Type</Label>
                                    <Input
                                        type="select"
                                        value={loanType}
                                        onChange={(e) => setLoanType(e.target.value)}
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Loan Type--</option>
                                        <option value="Crop Loans">Crop Loans</option>
                                        <option value="Loans for Agri Infrastructure">Loans for Agri Infrastructure</option>
                                        <option value="Livestock Loans">Livestock Loans</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Loan Amount</Label>
                                    <Input
                                        type="number"
                                        value={loanAmt}
                                        onChange={(e) => setLoanAmt(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Enter loan amount"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Loan Date</Label>
                                    <Input
                                        type="date"
                                        value={loanDate}
                                        onChange={(e) => setLoanDate(e.target.value)}
                                        className="form-control-sm"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Total Loan Payment</Label>
                                    <Input
                                        type="number"
                                        value={totLoanPayment}
                                        onChange={(e) => setTotLoanPayment(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Total amount paid"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Outstanding Amount</Label>
                                    <Input
                                        type="number"
                                        value={loanOutstandingAmt}
                                        onChange={(e) => setLoanOutstandingAmt(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Outstanding amount"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Cropping Pattern */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaSeedling className="text-success" />
                            <h6 className="mb-0 text-success">Cropping Pattern</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row className="mb-3">
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Season</Label>
                                    <Input
                                        type="select"
                                        value={season}
                                        onChange={(e) => {
                                            setSeason(e.target.value);
                                            setSeasonName(e.target.selectedOptions[0].text)
                                        }}
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Season--</option>
                                        <option value="1">Summer</option>
                                        <option value="2">Rainy</option>
                                        <option value="3">Winter</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Crop</Label>
                                    <Input
                                        type="select"
                                        value={crop}
                                        onChange={(e) => {
                                            setCrop(e.target.value);
                                            setCropName(e.target.selectedOptions[0].text)
                                        }}
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Crop--</option>
                                        <option value="1">Bitter Gourd</option>
                                        <option value="2">Chilli</option>
                                        <option value="3">Brinjal</option>
                                        <option value="4">Tomato</option>
                                        <option value="5">Amaranthus</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Financial Year</Label>
                                    <Input
                                        type="select"
                                        value={financialYear}
                                        onChange={(e) => setFinancialYear(e.target.value)}
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select FY--</option>
                                        <option value="2024-2025">2024-2025</option>
                                        <option value="2025-2026">2025-2026</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Area (Acres)</Label>
                                    <Input
                                        type="text"
                                        value={cropArea}
                                        onChange={(e) => setCropArea(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Area"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Harvesting</Label>
                                    <Input
                                        type="text"
                                        value={cropHarvesting}
                                        onChange={(e) => setCropHarvesting(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Harvesting details"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">&nbsp;</Label>
                                    <div>
                                        <Button
                                            color="success"
                                            size="sm"
                                            onClick={add_crop_pattern}
                                            className="text-white"
                                        >
                                            <FaPlus size={12} />
                                            Add
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>

                        {cropPtnList.length > 0 && (
                            <div className="mt-3">
                                <Alert color="success" className="mb-2">
                                    <FaSeedling className="me-2" />
                                    <strong>{cropPtnList.length}</strong> crop pattern(s) added
                                </Alert>
                                <div className="border rounded p-3 bg-light">
                                    {cropPtnListData}
                                </div>
                            </div>
                        )}
                    </CardBody>
                </Card>

                {/* Irrigation Facilities */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaTractor className="text-info" />
                            <h6 className="mb-0 text-info">Source of Irrigation</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row className="mb-3">
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Facility Type</Label>
                                    <Input
                                        type="select"
                                        value={facilityType}
                                        onChange={(e) => {
                                            setFacilityType(e.target.value);
                                            setFacilityTypeName(e.target.selectedOptions[0].text)
                                        }}
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Facility Type--</option>
                                        <option value="1">Well</option>
                                        <option value="2">Pond</option>
                                        <option value="3">Canal</option>
                                        <option value="4">Rainfed</option>
                                        <option value="5">Drip</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">&nbsp;</Label>
                                    <div>
                                        <Button
                                            color="info"
                                            size="sm"
                                            onClick={add_facility}
                                            className="text-white"
                                        >
                                            <FaPlus size={12} />
                                            Add
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>

                        {facilityList.length > 0 && (
                            <div className="mt-3">
                                <Alert color="info" className="mb-2">
                                    <FaTractor className="me-2" />
                                    <strong>{facilityList.length}</strong> irrigation facility(ies) added
                                </Alert>
                                <div className="border rounded p-3 bg-light">
                                    {facilityListData}
                                </div>
                            </div>
                        )}
                    </CardBody>
                </Card>

                {/* Land Area */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaLandmark className="text-secondary" />
                            <h6 className="mb-0 text-secondary">Land Area Details</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row className="mb-3">
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Plot No.</Label>
                                    <Input
                                        type="text"
                                        value={plotNo}
                                        onChange={(e) => setPlotNo(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Plot number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Holding No.</Label>
                                    <Input
                                        type="text"
                                        value={holdingNo}
                                        onChange={(e) => setHoldingNo(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Holding number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Area (Acres)</Label>
                                    <Input
                                        type="text"
                                        value={area}
                                        onChange={(e) => setArea(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Area in acres"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Area Type</Label>
                                    <Input
                                        type="select"
                                        value={areaType}
                                        onChange={(e) => {
                                            setAreaType(e.target.value);
                                            setAreaTypeName(e.target.selectedOptions[0].text)
                                        }}
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Area Type--</option>
                                        <option value="1">Don</option>
                                        <option value="2">Baid</option>
                                        <option value="3">Tanr</option>
                                        <option value="4">Kanali</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={1}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">&nbsp;</Label>
                                    <div>
                                        <Button
                                            color="secondary"
                                            size="sm"
                                            onClick={Add_land_area}
                                            className="text-white"
                                        >
                                            <FaPlus size={12} />
                                            Add
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>

                        {landList.length > 0 && (
                            <div className="mt-3">
                                <Alert color="secondary" className="mb-2">
                                    <FaLandmark className="me-2" />
                                    <strong>{landList.length}</strong> land record(s) added
                                </Alert>
                                <div className="border rounded p-3 bg-light">
                                    {landListData}
                                </div>
                            </div>
                        )}
                    </CardBody>
                </Card>

                {/* Submit Actions */}
                <Card className="border-0 shadow-sm">
                    <CardBody>
                        <Row>
                            <Col md={12} className="text-center">
                                <div className="d-flex gap-3 justify-content-center mb-2">
                                    <div className="mb-1">Form Progress</div>
                                    <div className="d-flex align-items-center gap-2">
                                        <Progress
                                            value={formProgress}
                                            color={formProgress === 100 ? "success" : "warning"}
                                            style={{ width: '300px', height: '8px' }}
                                        />
                                        <span className="fw-bold">{formProgress}%</span>
                                    </div>
                                </div>
                                <div className="d-flex gap-3 justify-content-center">
                                    <Button
                                        color="success"
                                        size="lg"
                                        type="submit"
                                        disabled={loading || formProgress < 100}
                                        className="d-flex align-items-center gap-2 px-4 text-white"
                                    >
                                        {loading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <FaSave />
                                        )}
                                        {loading ? 'Submitting...' : 'Submit & Save Farmer'}
                                    </Button>
                                    <Button
                                        color="secondary"
                                        size="lg"
                                        onClick={back}
                                        disabled={loading}
                                        className="d-flex align-items-center gap-2 px-4 text-white"
                                    >
                                        <FaArrowLeft />
                                        Back to List
                                    </Button>
                                </div>
                                {formProgress < 100 && (
                                    <small className="text-warning mt-2 d-block">
                                        <FaInfoCircle className="me-1" />
                                        Please complete all required fields to submit the form
                                    </small>
                                )}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Form>
        </>
    )
}

export default AddFarmer;